module.exports = __webpack_public_path__ + "static/media/critters.585ba5f7.png";